import {Component, OnDestroy, OnInit, ViewChild, EventEmitter, Output, Input, OnChanges} from '@angular/core';
import {ContractSettingsModel} from '../../../models/ContractSettingsModel';
import * as servers from '../../../services/api/servers';
import {urls} from '../../../services/api/urls';
import {ContractTypeSettingsService} from './service/contract-type-settings.service';
import {MatDialog, MatPaginator, MatSort, MatTableDataSource, PageEvent, Sort} from '@angular/material';
import {forkJoin, Observable, Subscription} from 'rxjs';
import {DialogDetailComponent} from '../../general-components/dialog-detail/dialog-detail.component';
import {GenericArray} from '../../../models/GenericArray';
import {Offset} from '../../../models/Offset';
import * as toastr from 'toastr';
import {LoaderService} from '../../general-services/service-loader/loader.service';
import {BaseGeneralComponent} from '../../BaseGeneralComponent';
import {ProviderAnagrafService} from '../../general-services/service-provider-anagraf/provider-anagraf.service';
import {LocalCustomerAnagrafService} from '../../general-services/service-local-customer-anagraf/local-customer-anagraf.service';
import {ContractTypeService} from '../../general-services/service-contract-type/contract-type.service';
import { Router } from '@angular/router';
import {AllSettingsFilterModel} from '../../../models/AllSettingsFilterModel';
import {UsersService} from '../../users/service/users.service';

@Component({
  selector: 'app-contract',
  templateUrl: './contract.component.html',
  styleUrls: ['./contract.component.scss']
})
export class ContractComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  sectionId: string;

  displayedColumns: Array<string>;
  dataSource: any;
  isContractSection: boolean;
  selectedRowIndex: number;
  listData: MatTableDataSource<any>;
  getAllSubscribe: Subscription;
  deleteElementSubscribe: Subscription;

  offset: Offset;
  filter: ContractSettingsModel;
  providerData: any;
  showNewEditDelete: boolean;
  showFilter: boolean;

  @Input() showActions?: boolean;
  @Input() idSelected?: number;
  @Input() inServiceChanges?: boolean;

  @Output() elementSelected = new EventEmitter();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;


  constructor(private contractTypeSettingsService: ContractTypeSettingsService,
              private userService: UsersService,
              private dialog: MatDialog,
              private loaderService: LoaderService,
              private providerService: ProviderAnagrafService,
              private router: Router) {
    super();
    this.loaderService.display(true);
    this.user = JSON.parse(sessionStorage.getItem('user'));
    this.sectionId = this.SECTIONS.SETTINGS;
    this.filter = new ContractSettingsModel();
  }

  ngOnInit() {
    this.isContractSection = this.returnIsContractSection(this.router.url);
    this.showNewEditDelete = !this.checkRole();
    this.showFilter = false;
    this.selectedRowIndex = this.idSelected;
    this.displayedColumns = ['ProviderDesc', 'RegionDesc', 'ContractTypeDesc', 'actions'];

    this.offset = this.setOffsetInSession(this.offset, this.OFFSET_NAME.CONTRACT_TYPE_SETTING_OFFSET);
    this.getSessionStorageFilter();
    this.userService.getUserSectionGrant(this.user.id, this.sectionId).subscribe(
      (result: any) => {
        this.setUserGrants(result);
      });
    this.init();
    }


  init() {
    const getFirstProviderObservable: Observable<any> = this.providerService.getListInContractTypeSetting(this.filter).pipe();

    getFirstProviderObservable.subscribe(
      (result: any) => {
        this.providerData = result;

        if (!this.filter.provider) {
          this.filter.provider = result ? result[0] : null;
        }

        this.getDataPage(this.offset, this.filter);
      }, error => {
        console.log(error);
      }
    );
  }


  getDataPage(offset: Offset, filter: ContractSettingsModel) {
    this.getAllSubscribe = this.contractTypeSettingsService.getPage(offset, filter)
      .subscribe(
        (result: any) => {
          this.dataSource = result.content;
          this.listData = new MatTableDataSource(this.dataSource);
          this.listData.sort = this.sort;
          this.paginator.pageIndex = offset.pageIndex;
          this.paginator.showFirstLastButtons = true;
          this.paginator.length = result.totalElements;
          this.loaderService.display(false);
        });
  }


  openDialog(item: ContractSettingsModel) {
    const list: GenericArray[] = [
      {id: 'Contract Type Cod ', value: this.toCustomString(item.contractType.cod)},
      {id: 'Contract Type Description ', value: this.toCustomString(item.contractType.description)},
      {id: 'Region Cod ', value: item.region ? item.region.cod : 'N.D.'},
      {id: 'Region Description ', value: item.region ? item.region.description : 'N.D.'},
      {id: 'Provider Cod', value: this.toCustomString(item.provider.cod)},
      {id: 'Provider Description', value: this.toCustomString(item.provider.description)}
    ];
    const dialogRef = this.dialog.open(DialogDetailComponent, {
      width: '40%',
      data: {list}
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });

  }

  getNext(event: PageEvent) {
    this.loaderService.display(true);
    const tmpOffset = new Offset(event.pageSize, event.pageIndex);
    this.setOffsetInSession(tmpOffset, this.OFFSET_NAME.CONTRACT_TYPE_SETTING_OFFSET);
    tmpOffset.orderDirection = this.offset.orderDirection;
    tmpOffset.orderField = this.offset.orderField;
    this.offset = tmpOffset;
    this.getDataPage(this.offset, this.filter);

  }

  deleteElement(id: number) {
    if (confirm('Sicuro di voler cancellare il dipendente selezionato?')) {
      this.loaderService.display(true);
      this.deleteElementSubscribe = this.contractTypeSettingsService.softDelete(id)
        .subscribe(
          (result: any) => {
            if (result) {
              toastr.success('Contract with id ' + id + ' was deleted with success', 'Success');
              this.getDataPage(this.offset, this.filter);
            } else {
              {
                toastr.info('Contract cannot be deleted', 'Alert');
              }
            }
            this.loaderService.display(false);
          }, (error => {
            toastr.error('Contract with id ' + id + ' was not deleted', 'Error');
            this.loaderService.display(false);
          })
        );
    }
  }

  getDataFiltered(dataFiltered: any) {
    if (this.offset === null || this.offset === undefined) {
      this.offset = new Offset(10, 0);
    }
    this.filter = dataFiltered;
    this.getDataPage(this.offset, this.filter);

  }

  sortData(sort: Sort) {
    this.loaderService.display(true);
    if ((sort.active !== null || true || sort.active !== '') && (sort.direction !== '' || sort.direction !== null || true)) {
      if (this.offset === null || this.offset === undefined) {
        this.offset = new Offset(10, 0);
      }

      this.offset.orderField = sort.active;
      this.offset.orderDirection = sort.direction;

      this.getDataPage(this.offset, this.filter);
    }


  }


  selectRow(row: any) {
    this.selectedRowIndex = row.id;
    this.elementSelected.emit({ row });
  }

  ngOnDestroy(): void {
    if (this.getAllSubscribe) {
      this.getAllSubscribe.unsubscribe();
    }
    if (this.deleteElementSubscribe) {
      this.deleteElementSubscribe.unsubscribe();
    }
  }

  toggleFilter() {
    this.showFilter = !this.showFilter;
  }

  getSessionStorageFilter() {
    const filter_ = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.CONTRACT_SETTING_FILTER));
    this.filter = filter_ ? filter_ : new ContractSettingsModel();
  }

}
